module.exports = __webpack_public_path__ + "img/product-vr2-m.7e43c2d8.jpg";